<template>
  <b-form-select
    v-bind="$attrs"
    :options="options"
    @change="handleChange"
    v-model="selectedBillingStatus"
    style="min-width: 220px;"
    class="form-control"
  >
    <template #first>
      <b-form-select-option :value="null">
        Status FAT
      </b-form-select-option>
    </template>
  </b-form-select>
</template>

<script>
import { PANORAMA_INVOICE_STATUS } from '../../constants';

export default {
  props: {
    value: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      selectedBillingStatus: this.value,
      options: Object.entries(PANORAMA_INVOICE_STATUS).map(
        ([statusKey, statusText]) => ({
          value: statusKey,
          text: statusText,
        }),
      ),
    };
  },
  methods: {
    handleChange() {
      this.$emit('input', this.selectedBillingStatus);
    },
  },
};
</script>
